export default __webpack_public_path__ + "locales/sr-Latn-RS/Files.json?hash=6332ba7dd5ffef95c783d005802361ae";